import { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, AppBar, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, FormControlLabel, Grid, Switch, TextField, Toolbar, Typography, useTheme } from "@mui/material"
import { useClientesService } from "../../../../../../use-cases/clientes/useClientesService"
import { useAppSelector } from "../../../../../hooks/store-hooks"
import CloseIcon from '@mui/icons-material/Close';
export const FormVincularProdutoCliente = () => {
  // State
  const { produtoConsumoVinculados } = useAppSelector((state) => state.clientes)
  // useTheme
  const theme = useTheme()
  const [searchTerms, setSearchTerms] = useState<{ [key: string]: string }>({})

  // Service
  const {
    setClientesOpenVincularProduto,
    toggleProdutoVinculado,
    toggleProdutoConsumoVinculado,
    updateProdutoConsumoVinculado,
    setProdutoVinculadoLimit
  } = useClientesService()
  // Function
  const handleClose = () => {
    setClientesOpenVincularProduto({
      open: false
    })
  }

  return (
    <Dialog
      open={true}
      fullScreen
      onClose={handleClose}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
      maxWidth={"lg"}
      PaperProps={{
        component: 'form',
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          updateProdutoConsumoVinculado();
        },
      }}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
            Vincular Produtos
          </Typography>
          <Button
            color="inherit"
            startIcon={<>
              <CloseIcon />
            </>}
            onClick={handleClose}
            aria-label="close"
          >
            Fechar
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent dividers={true}>
        <DialogContentText id="scroll-dialog-description" tabIndex={-1}></DialogContentText>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container>
              {produtoConsumoVinculados.map((produto) => (
                <Grid item xs={12} key={produto.produtoId}>
                  <Accordion sx={{

                  }} expanded={
                    produto.status
                  }>
                    <AccordionSummary sx={{
                      background: produto.status ? theme.palette.primary.main : undefined,
                      color: produto.status ? theme.palette.primary.contrastText : undefined
                    }} >
                      <Grid container spacing={3} alignItems={"center"}>
                        <Grid item>
                          <Checkbox color="secondary" onChange={(e) => {
                            toggleProdutoVinculado({
                              produtoId: produto.produtoId
                            })
                          }} checked={
                            produto.status
                          } />
                        </Grid>
                        <Grid item>
                          <Typography>{produto.produto}</Typography>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    {
                      produto.status && <AccordionDetails>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextField
                              color="primary"
                              variant="outlined"
                              label="Quantidade Consumo"
                              fullWidth
                              value={
                                produto.limit.toLocaleString()
                              }
                              onChange={(e) => {
                                let value: string | number = e.target.value
                                // cast to number
                                value = value.replace(/\D/g, '')
                                value = Number(value)
                                if (isNaN(value)) {
                                  value = 0
                                }
                                setProdutoVinculadoLimit({
                                  produtoId: produto.produtoId,
                                  limit: value
                                })
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sx={{ mb: 1, mt: 1 }}>
                            <TextField
                              size="small"
                              placeholder="Pesquisar consumo..."
                              variant="outlined"
                              fullWidth
                              value={searchTerms[produto.produtoId] || ''}
                              onChange={(e) => setSearchTerms(prev => ({
                                ...prev,
                                [produto.produtoId]: e.target.value
                              }))}
                            />
                          </Grid>
                          {produto.consumos
                            .filter(consumo =>
                              !searchTerms[produto.produtoId] ||
                              consumo.nome.toLowerCase().includes(searchTerms[produto.produtoId].toLowerCase())
                            )
                            .map((consumo) => {
                              return <Grid item xs={12} key={`${produto.produtoId}- ${consumo.tipoConsumoId}`}>
                                <FormControlLabel control={<Switch checked={
                                  consumo.status
                                } onChange={(e) => {
                                  toggleProdutoConsumoVinculado({
                                    produtoId: produto.produtoId,
                                    consumoId: consumo.tipoConsumoId
                                  })
                                }} />} label={consumo.nome} />

                              </Grid>
                            })}

                        </Grid>
                      </AccordionDetails>
                    }

                  </Accordion>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button type="submit" variant="contained">
          Vincular Produtos
        </Button>
      </DialogActions>
    </Dialog>
  )
}